<template>
  <div class="box">
    <div class="page">
      <div class="subpage">
        <div style="width: 360px; height: 66px; margin: auto">
          <a style="height: auto" href="https://www.gospel-event.com/">
            <img width="360" src="https://gospelapp-b51ce.web.app/img/logo2.f3801afd.png" />
          </a>
        </div>
        <br />
        <br />
        <br />
        <p class="c18">
          <span class="c85 c91"><br /></span>
        </p>
        <div v-if="data.type == 0">
          <p class="c22"><span class="c57">VOUS ÊTES DES PARTICULIERS</span></p>
          <p class="c22">
            <span class="c2">Vos noms et prénoms: {{ data.Nom }} {{ data.Prénom }} </span>
          </p>
          <p class="c22">
            <span class="c2">Votre adresse postale: {{ data.adressePostaleParticulier }} </span>
          </p>

          <p class="c22">
            <span class="c2"
              >Tel fixe&nbsp;et mobiles&nbsp;pour vous joindre: {{ data.telFixe }}
              {{ data.telMob }} {{ data.tel }}</span
            >
          </p>
          <p class="c22">
            <span class="c2"
              >Votre adresse mail principale avec laquelle vous nous avez écrit:
              {{ data.mail }}
            </span>
          </p>
          <p class="c22">
            <span class="c35"
              >Si vous n’êtes pas un des mariés, quel est lien de parenté avec le couple: <br
            /></span>
          </p>
        </div>
        <div v-else>
          <p class="c22">
            <span class="c57">VOUS ÊTES UNE AGENCE OU UNE ENTREPRISE</span>
          </p>
          <p class="c22">
            <span class="c2"
              >Nom de la structure, Siret et code APE:
              {{ data.nomDeLaStructure }}
              {{ data.Siret }}
              {{ data.CodeAPE }}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            >
          </p>
          <p class="c22">
            <span class="c2"
              >Représentée par (en sa qualité de):
              {{ data.représentant }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            >
          </p>
          <p class="c22">
            <span class="c2">Adresse postale de correspondance: {{ data.Adresse }}</span>
          </p>
          <p class="c22">
            <span class="c2"
              >Vos numéros de téléphone fixes et mobiles: {{ data.telFixe }} {{ data.telMob }}</span
            >
          </p>
        </div>

        <p class="c22 c62"><span class="c79 c109"></span></p>
        <p class="c22"><span class="c57">LE GROUPE DE GOSPEL</span></p>
        <p class="c22">
          <span class="c2"
            >Nom du groupe de Gospel que vous souhaitez retenir: {{ data.groupe }}
          </span>
        </p>
        <p class="c22">
          <span class="c2"
            >Combien de chanteurs et musiciens souhaités: {{ data.nbChanteurs }}
          </span>
        </p>
        <p class="c22">
          <span class="c35"
            >Tarif de cette formule indiquée sur le devis (déplacements inclus): {{ data.tarif }}
            <br />Merci de compléter l’autorisation de prélèvement en 3</span
          ><span class="c17">e</span
          ><span class="c35">&nbsp;page de ce bon de commande.<br /><br /></span
          ><span class="c57">LA PRÉPARATION DE L’ÉVÉNEMENT</span>
        </p>
        <p class="c22">
          <span class="c2"
            >Date de la cérémonie : {{ formatDate(data.date) }}<br />Nom de la ville:
            {{ data.nomVille }}
          </span>
        </p>
        <p class="c16">
          <span class="c2">Code postal de cette commune: {{ data.cp }} </span>
        </p>
        <p class="c16">
          <span class="c2"
            >Type de lieu de la cérémonie (église, domaine, mairie,..):
            {{ data.lieuCérémonie }}
          </span>
        </p>
        <p class="c16">
          <span class="c2">Lien Google Maps du lieu de la prestation (important)&nbsp;: </span>
        </p>
        <p class="c16">
          <span class="c2" style="overflow-wrap: break-word">
            <a :href="data.lienGoogleMapslieuCérémonie"> {{ data.lienGoogleMapslieuCérémonie }}</a>
          </span>
        </p>
        <p class="c16">
          <span class="c2"
            >Adresse précise du lieu de la cérémonie (pour vérification) :
            {{ data.AdresselieuCérémonie }} <br />Personne référente (autre que vous) qui recevra un
            SMS pour informer de l’arrivée du groupe&nbsp;: <br />Nom-Prénom :
            {{ data.personneRefNomPrenom }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tél mobile:
            {{ data.personneRefTel }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Quel lien familial/amical:
            {{ data.personneRefLien }} &nbsp;</span
          >
        </p>
        <p class="c16">
          <span class="c35">Heure&nbsp;précise du début de l’événement </span
          ><span class="c25">(le groupe arrivera 90 min avant) </span
          ><span class="c2"
            >: {{ data.heureDebEven }} &nbsp; <br />Si vous avez une wedding planner, nous indiquer
            son nom, mail, téléphone :
            {{ data.dureeCer }}
            <br />Type de cérémonie:
            {{ data.typeCer }}
          </span>
        </p>
        <p class="c16">
          <span class="c2"
            >Tenues souhaitées pour le groupe (toges gospel OU tenues noires de soirée) :
            {{ data.tenues }}
          </span>
        </p>
        <p class="c16">
          <span class="c2"
            >S’agit-il d’une surprise pour l’un des mariés: {{ data.surprise }}
          </span>
        </p>
        <p class="c16">
          <span class="c2">Nombre d’invités attendus: {{ data.nbInvites }} </span>
        </p>
        <p class="c16">
          <span class="c2"
            >Avez-vous d’autres demandes ou suggestions artistiques à proposer au groupe:
            {{ data.autresDemandes }}
          </span>
        </p>
        <p class="c32 c87"><span class="c2"></span></p>
        <p class="c22">
          <span class="c57"
            >Si cérémonie avec 200 invités en intérieur ou tout simplement en extérieur, une
            sonorisation est nécessaire. Le groupe peut la gérer lui-même pour un léger supplément
            (contacter Virginie au 07 68 88 94 36).<br />Autrement merci de nous donner les
            précisions suivantes :
          </span>
          <!-- <span class="c3">(sonorisation non gérée par le groupe)</span> -->
        </p>
        <p class="c16">
          <span class="c2"
            >Contact de la personne qui devra mettre en place et gérer la sonorisation durant toute
            la prestation du groupe: {{ data.nomPerGerSono }}
          </span>
        </p>
        <p class="c16">
          <span class="c2"
            >Cette personne a-t-elle confirmé qu’elle respectera parfaitement la fiche technique:
            {{ data.confRespFichTechSono }} <br
          /></span>
        </p>
        <hr style="page-break-before: always; display: none" />
        <p class="c5 c87 c105"><span class="c31"></span></p>
      </div>
    </div>
    <div class="page">
      <div class="subpage">
        <p class="c20 c39">
          <span class="c69">Conditions générales de vente</span>
        </p>
        <p class="c0"><span class="c45"></span></p>
        <p class="c8">
          <span class="c2"
            >La SARL SAY PRODUCTION (nom de marque GOSPEL EVENT), au capital de 5.000 €, No de Siret
            512 972 803 000 13 , dont le siège est situé au 45 grand rue, 34260
            CEILHES, réalise des prestations de chants Gospel pour cérémonies et concerts. Vous
            pouvez nous joindre au 07 68 88 94 36, ou par mail à virginie.gospelevent@icloud.com
            <br />Dès réception de votre commande, nous la vérifions et nous la transmettons
            immédiatement au coordinateur du groupe que vous souhaitez réserver. <br />
            Si ce groupe ne peut valider votre bon de commande, celui-ci sera automatiquement annulé
            mais nous pourrons si vous le souhaitez, vous aider à réserver un autre groupe.
            <br />
            Si le groupe valide, nous vous attestons cela par retour de mail. Ce bon de commande
            sera ensuite signé électroniquement, nous engageant fermement mutuellement pour la
            prestation.

            <br />La prestation sera composée de maximum 7 chants. Le nombre sera notamment
            déterminé par le plan de messe négocié entre vous et l’officiant. Le groupe ne prendra
            pas en charge les chants religieux en français. <br />
            Si le jour de la cérémonie doit commencer avec plus de 30 minutes de retard par rapport
            à l’heure convenue initialement sur le bon de commande, les artistes pourront négocier
            auprès de vous une réduction de la durée des chants ou supprimer certaines chansons.
            Ceci devant alors avoir lieu avec le maximum de concertation et de courtoisie avec vous.
            <br />En cas de changement d’heure de la célébration, vous vous engagez à informer au
            plus tôt Gospel Event par mail, qui devra valider le nouvel horaire par retour de mail.
            Si ce changement d’horaire entraîne trop de contraintes pour les artistes (par exemple :
            Impossibilité d’assurer un autre contrat prévu en soirée le même jour), Gospel Event
            pourra refuser ce changement d’heure, ceci entraînant une rupture de contrat de la part
            du client. Comme toujours, un arrangement à l’amiable sera privilégié. <br />En cas de
            pluie pendant une cérémonie en extérieur, les artistes devront interrompre leur
            prestation pour mettre leur matériel à l’abri. La pluie n’étant pas une cause
            d’annulation, car vous êtes censé avoir prévu un lieu de repli pour poursuivre votre
            cérémonie.
          </span>
        </p>

        <p class="c8">
          <span class="c76 c60">Votre règlement :</span
          ><span class="c35 c79 c60"
            >&nbsp;<br />
            Il se fait par prélèvement, jusque 3 fois maximum sans frais avant la prestation. Un
            acompte de 30% devra être réglé par prélèvement sous 10 jours après réception de votre
            commande. Deux autres prélèvements interviennent comme suit : 40% quatre mois avant
            l’événement et 30% un mois avant. Exemple : prestation à 1099€ = 329,70€ à la commande,
            439,60€ quatre mois avant, 329,70€ un mois avant.
            <br />Nous respecterons scrupuleusement les dates que vous nous aurez indiquées, 
            et que nous pourrons changer à tout moment à votre demande.
          </span>
        </p>

        <p class="c83 c101">
          <span class="c2"
            >Si un prélèvement est rejeté par votre banque, nous vous recontacterons au plus vite
            pour convenir ensemble d’une autre date de prélèvement. Un prélèvement rejeté entraine
            des frais bancaires de 10€ appliqués par notre banque, qui seront ajoutés à votre
            prochain prélèvement.<br />Sans nouvelle de votre part suite à ce rejet, et si nous ne trouvons pas de solution à l’amiable, cette
            prestation sera considérée comme étant annulée de votre fait, et les conditions d’annulation 
            ci-dessous s’appliqueront. <br />Nous respecterons scrupuleusement les dates que vous nous
            aurez indiquées, et que nous pourrons changer à tout moment à votre demande. <br />Deux
            jours après votre cérémonie nous vous contacterons par téléphone pour nous assurer de
            votre entière satisfaction. <br />Par l’envoi de ce bon de commande, vous attestez
            également que votre officiant accepte l’intervention du groupe et que vous serez en
            mesure de préparer votre répertoire (à inclure dans le plan de cérémonie) au plus tard 2
            mois avant l’événement, ceci afin d’éviter une préparation trop précipitée. <br />Si
            l’officiant devait à un moment des préparatifs ou de la cérémonie le jour J, revoir le
            nombre de chants ou leur durée, ceci ne saurait constituer une condition d’annulation de
            commande. <br />Si à la suite de l’événement, des amis ou des connaissances demandent le
            contact du groupe, le client s’engage à fournir uniquement le lien du site web Gospel
            Event : www.gospel-event.com
          </span>
        </p>
        <p class="c0"><span class="c31"></span></p>
        <p class="c8">
          <span class="c51">En cas de report de votre événement&nbsp;:</span
          ><span class="c2"
            >&nbsp;<br />Les règlements reçus restent acquis à Gospel Event. Vous disposez de 6 mois
            pour nous indiquer la nouvelle date de la prestation.
          </span>
        </p>
        <p class="c0"><span class="c31"></span></p>
        <p class="c8">
          <span class="c76">En cas de demande d’annulation de cette commande :</span
          ><span class="c2"
            >&nbsp;<br />. Gospel Event n’a jamais annulé une prestation. Toutefois afin de vous
            sécuriser, si cela devait arriver nous nous engageons évidement à vous rétrocéder vos
            règlements déjà effectués, mais également à vous dédommager d’une somme égale au montant
            de la prestation annoncée en première page de ce bon de commande. <br />. Si vous
            souhaitez annuler vous-même cette commande, et que votre demande d’annulation nous
            parvient plus de quatre mois avant la date de votre événement, votre commande sera
            annulée. Il vous suffit d’obtenir un accusé de réception par mail de notre part.
            Toutefois les 30% déjà perçus ne vous seront pas remboursés. <br />. Si votre demande
            d’annulation nous parvient moins de quatre mois avant la date de votre événement, vous
            nous serez redevable d’une somme de dédommagement du montant intégral de cette
            prestation (moins les frais de déplacements). <br />. En cas d’annulation reconnue de «
            force majeure », la prestation sera annulée et remboursée seulement si vous pouvez
            apporter la preuve formelle qu’un report est impossible. <br />En cas de litige portant
            sur l’interprétation ou l’application de cette commande : les parties conviennent de
            s’en remettre à l’appréciation du Tribunal de Montpellier.
          </span>
        </p>
      </div>
    </div>
    <div class="page">
      <div class="subpage">
        <br /><br />

        <p class="c15"><span class="c4">AUTORISATION DE PRÉLÈVEMENT</span></p>
        <p class="c5"><span class="c31"></span></p>
        <p class="c15">
          <span class="c25 c79 c82"
            >(Numéro ICS de Say Production&nbsp;délivré par les autorités bancaires de France&nbsp;:
            FR03ZZZ856E67)</span
          >
        </p>
        <p class="c32"><span class="c79 c82 c90"></span></p>
        <p class="c8">
          <span class="c2"
            >En complétant le formulaire ci-dessous, qui tient lieu de mandat de prélèvement SEPA,
            et en nous le retournant par mail dans ce bon de commande, cela vous revient à signer
            électroniquement cette autorisation de prélèvement.</span
          >
        </p>
        <p class="c32"><span class="c73"></span></p>
        <p class="c8">
          <span class="c2"
            >À aucun moment Say Production ne pourra déroger aux informations complétées ci-dessous
            par vos soins, en procédant par exemple à une demande de prélèvement avec une autre
            somme ou en décalant une date, sous peine de poursuite.</span
          >
        </p>
        <p class="c32"><span class="c73"></span></p>
        <p class="c8">
          <span class="c2"
            >À tout moment vous pouvez également nous contacter pour modifier cette autorisation de
            prélèvement.</span
          >
        </p>
        <p class="c32"><span class="c73"></span></p>
        <p class="c32"><span class="c45"></span></p>
        <a id="t.a5536254071dc36397eee52c0dfa4ada400177b2"></a><a id="t.0"></a>
        <table class="c38">
          <tbody>
            <tr class="c78">
              <td class="c58" colspan="1" rowspan="1">
                <p class="c20">
                  <span class="c85 c93">ADRESSE MAIL DU DÉTENTEUR DU COMPTE&nbsp;: </span>
                </p>
              </td>
              <td class="c36" colspan="1" rowspan="1">
                <p class="c33 c62">
                  <span class="c2">{{ data["emailIban"] }}</span>
                </p>
              </td>
            </tr>
            <tr class="c78">
              <td class="c58" colspan="1" rowspan="1">
                <p class="c20">
                  <span class="c61">NOM DE LA PERSONNE DÉBITÉE :</span>
                </p>
              </td>
              <td class="c36" colspan="1" rowspan="1">
                <p class="c33">
                  <span class="c2">&nbsp;{{ data["nomDeLaPersIban"] }}</span>
                </p>
              </td>
            </tr>
            <tr class="c80">
              <td class="c58" colspan="1" rowspan="1">
                <p class="c20"><span class="c61">PRÉNOM DE LA PERSONNE :</span></p>
              </td>
              <td class="c36" colspan="1" rowspan="1">
                <p class="c33">
                  <span class="c2">&nbsp; {{ data["prenomDeLaPersIban"] }}</span>
                </p>
              </td>
            </tr>
            <tr class="c116">
              <td class="c58" colspan="1" rowspan="1">
                <p class="c20">
                  <span class="c61">SON ADRESSE&nbsp; POSTALE :</span>
                </p>
              </td>
              <td class="c36" colspan="1" rowspan="1">
                <p class="c33">
                  <span class="c2">&nbsp; {{ data["adresseDeLaPersIban"] }}</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="c18"><span class="c2"></span></p>
        <p class="c8">
          <span class="c61">autorise la sarl Say Production – Gospel Event</span
          ><span class="c2"
            >, basée au 45 grand rue, 34260 Ceilhes, à envoyer des instructions à votre banque pour
            débiter le compte courant ci-dessous :</span
          >
        </p>
        <p class="c18"><span class="c2"></span></p>
        <a id="t.db944605264db5e5eae5f2af6a2efadb2d7820c1"></a><a id="t.1"></a>
        <table class="c38">
          <tbody>
            <tr class="c114">
              <td class="c49" colspan="1" rowspan="1">
                <p class="c24">
                  <span class="c61">IBAN DU COMPTE COURANT (sans espace)</span>
                </p>
              </td>
            </tr>
            <tr class="c104">
              <td class="c99" colspan="1" rowspan="1">
                <p class="c62 c112 pt-1">
                  <span class="c2">{{ data["iban"] }}</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="c32"><span class="c73"></span></p>
        <p class="c8">
          <span class="c2">pour effectuer le(s) prélèvement(s) suivant(s) : </span>
        </p>
        <!-- RÈGLEMENT EN 1 FOIS -->
        <div
          v-if="data.reglementType23 == '-1'"
          style="max-width: 500px"
          class="d-flex flex-column justify-content-center mx-auto"
        >
          <v-simple-table style="width: 100%">
            <template v-slot:default>
              <thead>
                <tr>
                  <th colspan="4" class="text-center">
                    <div class="text-h6">RÈGLEMENT EN 1 FOIS</div>
                    <!-- <div class="text-subtitle-1">
                                montants et dates modifiables par vos soins
                              </div> -->
                  </th>
                </tr>
                <tr>
                  <th class="text-left" style="width: 35%"></th>
                  <th class="text-center" style="width: 25%">MONTANT</th>
                  <th class="text-center" style="width: 20%">MOIS</th>
                  <th class="text-center" style="width: 20%">ANNÉE</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-left">100% (à la commande)</td>
                  <td class="text-center">
                    <div class="centered-input" auto-grow rows="1" hide-details="auto" solo>
                      {{ data["MONTANT100"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input" auto-grow rows="1" hide-details="auto" solo>
                      {{ data["MOIS100"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input" auto-grow rows="1" hide-details="auto" solo>
                      {{ data["ANNÉE100"] }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <!-- cases -->
        </div>
        <!-- RÈGLEMENT EN 2 FOIS -->
        <div
          v-if="data.reglementType23 == '0'"
          style="max-width: 500px; margin-right: auto !important; margin-left: auto !important"
          class="d-flex flex-column justify-content-center"
        >
          <v-simple-table style="width: 100%">
            <template v-slot:default>
              <thead>
                <tr>
                  <th colspan="4" class="text-center">
                    <span class="text-h6"> RÈGLEMENT EN 2 FOIS </span>
                  </th>
                </tr>
                <tr>
                  <th class="text-left" style="width: 35%"></th>
                  <th class="text-center" style="width: 20%">MONTANT</th>
                  <th class="text-center" style="width: 20%">MOIS</th>
                  <th class="text-center" style="width: 20%">ANNÉE</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-left">Acompte 30% (à la commande)</td>
                  <td class="text-center">
                    <div class="centered-input" auto-grow rows="1" hide-details="auto" solo>
                      {{ data["MONTANT30"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input" auto-grow rows="1" hide-details="auto" solo>
                      {{ data["MOIS30"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input" auto-grow rows="1" hide-details="auto" solo>
                      {{ data["ANNÉE30"] }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-left">Solde 70% (4 mois avant l’événement)</td>
                  <td class="text-center">
                    <div class="centered-input" auto-grow rows="1" hide-details="auto" solo>
                      {{ data["MONTANT70"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input" auto-grow rows="1" hide-details="auto" solo>
                      {{ data["MOIS70"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input" auto-grow rows="1" hide-details="auto" solo>
                      {{ data["ANNÉE70"] }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <!-- cases -->
        </div>

        <!-- RÈGLEMENT EN 2 FOIS -->
        <div
          v-if="data.reglementType23 == '1'"
          style="max-width: 500px; margin-right: auto !important; margin-left: auto !important"
        >
          <v-simple-table style="width: 100%">
            <template v-slot:default>
              <thead>
                <tr>
                  <th colspan="4" class="text-center">
                    <span class="text-h6"> RÈGLEMENT EN 3 FOIS </span>
                  </th>
                </tr>
                <tr>
                  <th class="text-left" style="width: 35%"></th>
                  <th class="text-center" style="width: 20%">MONTANT</th>
                  <th class="text-center" style="width: 20%">MOIS</th>
                  <th class="text-center" style="width: 20%">ANNÉE</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-left">Acompte 30% <br />(à la commande)</td>
                  <td class="text-center">
                    <div class="centered-input">
                      {{ data["MONTANT303"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input">
                      {{ data["MOIS303"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input">
                      {{ data["ANNÉE303"] }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-left">Solde 40% <br />(4 mois avant l’événement)</td>
                  <td class="text-center">
                    <div class="centered-input">
                      {{ data["MONTANT403"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input">
                      {{ data["MOIS403"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input">
                      {{ data["ANNÉE403"] }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-left">Solde 30% <br />(1 mois avant l’événement)</td>
                  <td class="text-center">
                    <div class="centered-input">
                      {{ data["MONTANT30_3"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input">
                      {{ data["MOIS30_3"] }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="centered-input">
                      {{ data["ANNÉE30_3"] }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <!-- cases -->
        </div>
        <v-select
          class="mt-3"
          outlined
          v-model="data['datePrelevement']"
          :items="$store.state.datesPrelevement"
          messages="Choisissez le jour le jour souhaité de vos prélèvements dans la liste"
        >
        </v-select>
        <br />
        <p class="c10 c6">
          Document complété le : {{ formatDate(data["documentComplLe"]) }} à
          {{ data.à }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "pdfToPrint",
  props: ["data"],
  methods: {
    // data: () => ({
    //   test: {
    //     id: "c3r3ki6i",
    //     Nom: " Leger",
    //     Prénom: " Marie gaelle",
    //     adressePostaleParticulier: " 1 rue de l’ecole 02000 bourguignon sous montbavin",
    //     reglementType23: 1,
    //     e6: 9,
    //     copieDansFC: true,
    //     type: "0",
    //     Origine: "",
    //     mail: "uurkat@hotmail.fr",
    //     Siret: " ",
    //     CodeAPE: " ",
    //     nomDeLaStructure: " ",
    //     tel: " 0629984076",
    //     telMob: " ",
    //     représentant: " ",
    //     Adresse: " ",
    //     telFixe: " ",
    //     groupe: "Gospel Feel",
    //     nbChanteurs: "3 choristes dont 1 pianiste",
    //     tarif: "1399",
    //     surprise: "Non",
    //     nomVille: "Royaucourt-et-chailvet",
    //     date: "2024-07-27",
    //     cp: "02000",
    //     lieuCérémonie: "église",
    //     lienGoogleMapslieuCérémonie: "https://maps.app.goo.gl/qMe6TxSDVQ9TqukA8",
    //     AdresselieuCérémonie:
    //       "église St Julien, 2 Rue du Chanoine Fox, 02000 Royaucourt-et-Chailvet",
    //     personneRefNomPrenom: "Leger jesse",
    //     personneRefTel: "0782695328",
    //     personneRefLien: "Frégate ",
    //     heureDebEven: "15h",
    //     dureeCer: "1h",
    //     tenues: "Toges",
    //     nbInvites: "180",
    //     autresDemandes: "",
    //     nomPerGerSono: "Leger",
    //     confRespFichTechSono: "Leger ",
    //     iban: "FR7630004017060000060415552",
    //     documentComplLe: "2024-07-03",
    //     adresseDeLaPersIban: "1 rue de l’école 02000 bourguignon sous montbavin",
    //     prenomDeLaPersIban: "Marie ",
    //     nomDeLaPersIban: "Leger",
    //     emailIban: "uurkat@hotmail.fr",
    //     datePrelevement: "au 15",
    //     MONTANT30: " 699,50",
    //     MOIS30: " 7",
    //     ANNÉE30: " 2024",
    //     MONTANT70: "  699,50",
    //     MOIS70: " 8",
    //     ANNÉE70: " 2024",
    //     MONTANT303: " ",
    //     MOIS303: " ",
    //     ANNÉE303: " ",
    //     MONTANT403: " ",
    //     MOIS403: " ",
    //     ANNÉE403: " ",
    //     MONTANT30_3: " ",
    //     MOIS30_3: " ",
    //     ANNÉE30_3: " ",
    //     "Document complété le": "",
    //     à: "Bourguignon sous montbavin ",
    //     emailSent: "",
    //     typeCer: "Mariage",
    //     row: 619,
    //   },
    // }),
    formatDate(date) {
      if (!date) return null;
      var da = new Date(date);
      const [year, month, day] = [
        da.getUTCFullYear(),
        ("0" + (da.getUTCMonth() + 1)).slice(-2),
        ("0" + da.getUTCDate()).slice(-2),
      ];
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
<style type="text/css" scoped>
@import url("https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLfpjyB5BQourYAyA--No9iX43MHGdcUk8lVDt-hm-NLh");
.lst-kix_list_1-3 > li:before {
  content: "\0025aa  ";
}
.lst-kix_list_1-4 > li:before {
  content: "\01f8ad  ";
}
ul.lst-kix_list_1-0 {
  list-style-type: none;
}
.lst-kix_list_1-7 > li:before {
  content: "\0025aa  ";
}
.lst-kix_list_1-5 > li:before {
  content: "\0025cf  ";
}
.lst-kix_list_1-6 > li:before {
  content: "o  ";
}
ul.lst-kix_list_1-3 {
  list-style-type: none;
}
.lst-kix_list_1-0 > li:before {
  content: "  ";
}
ul.lst-kix_list_1-4 {
  list-style-type: none;
}
.lst-kix_list_1-8 > li:before {
  content: "\01f8ad  ";
}
ul.lst-kix_list_1-1 {
  list-style-type: none;
}
ul.lst-kix_list_1-2 {
  list-style-type: none;
}
ul.lst-kix_list_1-7 {
  list-style-type: none;
}
.lst-kix_list_1-1 > li:before {
  content: "\0025cf  ";
}
.lst-kix_list_1-2 > li:before {
  content: "o  ";
}
ul.lst-kix_list_1-8 {
  list-style-type: none;
}
ul.lst-kix_list_1-5 {
  list-style-type: none;
}
ul.lst-kix_list_1-6 {
  list-style-type: none;
}
ol {
  margin: 0;
  padding: 0;
}
table td,
table th {
  padding: 0;
}
.c65 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.5pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c42 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c49 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 326.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c99 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #ffffff;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 326.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c100 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 71.7pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c55 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c88 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c58 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 233.9pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c66 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.3pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c81 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 324.9pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c50 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 71.7pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c64 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 64.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c70 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 71.7pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c13 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 25.6pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c26 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.3pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c12 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c98 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 64.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c43 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c67 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.3pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c40 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 124.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c52 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.3pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c19 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c56 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.5pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c63 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c110 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 71.7pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c71 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c103 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 121pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c106 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.5pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c11 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 184pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c30 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.3pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c37 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 71.7pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c29 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c36 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 276.4pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c97 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c96 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 124.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c9 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 124.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c107 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 121.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c102 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 219.6pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c77 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c7 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 64.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c94 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.5pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c27 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 64.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c74 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 124.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c0 {
  margin-left: -28.4pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
  margin-right: -28.4pt;
  height: 5pt;
}
.c8 {
  margin-left: -28.4pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
  margin-right: -28.4pt;
}
.c115 {
  margin-left: -35.5pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: center;
  margin-right: -40pt;
}
.c22 {
  margin-left: -21.2pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
  margin-right: -21.2pt;
}
.c51 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-style: normal;
}
.c18 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: left;
  height: 12pt;
}
.c1 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 12pt;
  font-family: "Calibri";
  font-style: normal;
}
.c31 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 5pt;
  font-family: "Arial";
  font-style: normal;
}
.c75 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10.5pt;
  font-family: "Arial";
  font-style: normal;
}
.c45 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 6pt;
  font-family: "Arial";
  font-style: normal;
}
.c59 {
  color: #365f91;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-style: normal;
}
.c32 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
  height: 12pt;
}
.c53 {
  color: #366092;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 16pt;
  font-family: "Calibri";
  font-style: normal;
}
.c16 {
  margin-left: -21.3pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c73 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 8pt;
  font-family: "Arial";
  font-style: normal;
}
.c21 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Calibri";
  font-style: normal;
}
.c2 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-style: normal;
}
.c23 {
  color: #365f91;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-style: normal;
}
.c5 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: center;
  height: 12pt;
}
.c6 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Arial";
  font-style: normal;
}
.c112 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1500000000000001;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c33 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c15 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: center;
}
.c68 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c10 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 2;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c24 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c20 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: center;
}
.c3 {
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  color: #333399;
  font-weight: 400;
}
.c84 {
  color: #4f4f4f;
  font-weight: 400;
  vertical-align: baseline;
  font-size: 4pt;
  font-family: "Arial";
}
.c47 {
  vertical-align: super;
  font-size: 11pt;
  font-family: "Arial";
  color: #000000;
  font-weight: 400;
}
.c44 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  text-align: left;
  height: 12pt;
}
.c14 {
  vertical-align: baseline;
  font-size: 16pt;
  font-family: "Calibri";
  color: #366092;
  font-weight: 700;
}
.c34 {
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Calibri";
  color: #000000;
  font-weight: 400;
}
.c4 {
  vertical-align: baseline;
  font-size: 16pt;
  font-family: "Arial";
  color: #365f91;
  font-weight: 700;
}
.c113 {
  color: #365f91;
  font-weight: 400;
  vertical-align: baseline;
  font-size: 16pt;
  font-family: "Arial";
}
.c69 {
  vertical-align: baseline;
  font-size: 15pt;
  font-family: "Arial";
  color: #333399;
  font-weight: 700;
}
.c109 {
  color: #333399;
  font-weight: 400;
  vertical-align: baseline;
  font-size: 4pt;
  font-family: "Arial";
}
.c101 {
  margin-left: -28.4pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
}
.c57 {
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  color: #333399;
  font-weight: 700;
}
.c48 {
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Arial";
  color: #000000;
  font-weight: 400;
}
.c38 {
  margin-left: -28.4pt;
  border-spacing: 0;
  border-collapse: collapse;
  margin-right: auto;
}
.c89 {
  font-weight: 400;
  vertical-align: baseline;
  font-size: 12pt;
  font-family: "Arial";
}
.c76 {
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-weight: 700;
}
.c17 {
  vertical-align: super;
  font-size: 10pt;
  font-family: "Arial";
  font-weight: 400;
}
.c35 {
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-weight: 400;
}
.c25 {
  vertical-align: baseline;
  font-size: 9pt;
  font-family: "Arial";
  font-weight: 400;
}
.c41 {
  vertical-align: baseline;
  font-family: "Calibri";
  color: #000000;
  font-weight: 400;
}
.c90 {
  font-weight: 400;
  vertical-align: baseline;
  font-size: 18pt;
  font-family: "Arial";
}
.c86 {
  font-weight: 400;
  vertical-align: baseline;
  font-size: 5pt;
  font-family: "Arial";
}
.c111 {
  font-weight: 400;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Comic Sans MS";
}
.c117 {
  margin-left: -5.4pt;
  border-spacing: 0;
  border-collapse: collapse;
  margin-right: auto;
}
.c61 {
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Arial";
  font-weight: 700;
}
.c72 {
  background-color: #ffffff;
  /* max-width: 453.6pt; */
  padding: 21.3pt 70.8pt 7.1pt 70.8pt;
}
.c85 {
  vertical-align: baseline;
  font-family: "Arial";
  font-weight: 700;
}
.c79 {
  text-decoration: none;
  font-style: normal;
}
.c92 {
  margin-left: -70.9pt;
  margin-right: -70.9pt;
}
.c39 {
  margin-left: -21.3pt;
  margin-right: -21.3pt;
}
.c95 {
  height: 11pt;
}
.c54 {
  height: 31pt;
}
.c93 {
  font-size: 10.5pt;
}
.c87 {
  margin-left: -21.3pt;
}
.c78 {
  height: 29.4pt;
}
.c62 {
  height: 12pt;
}
.c104 {
  height: 20.2pt;
}
.c91 {
  font-size: 6pt;
}
.c108 {
  margin-left: -28.4pt;
}
.c60 {
  color: #ff0000;
}
.c28 {
  height: 15pt;
}
.c83 {
  margin-right: -28.4pt;
}
.c80 {
  height: 27.7pt;
}
.c116 {
  height: 28.1pt;
}
.c46 {
  height: 13.7pt;
}
.c105 {
  margin-right: -21.2pt;
}
.c82 {
  color: #000000;
}
.c114 {
  height: 0pt;
}
.title {
  padding-top: 24pt;
  color: #000000;
  font-weight: 700;
  font-size: 36pt;
  padding-bottom: 6pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.subtitle {
  padding-top: 18pt;
  color: #666666;
  font-size: 24pt;
  padding-bottom: 4pt;
  font-family: "Georgia";
  line-height: 1;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left;
}
li {
  color: #000000;
  font-size: 12pt;
  font-family: "Times";
}
p {
  margin: 0;
  color: #000000;
  font-size: 12pt;
  font-family: "Times";
}
h1 {
  padding-top: 24pt;
  color: #000000;
  font-weight: 700;
  font-size: 24pt;
  padding-bottom: 6pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h2 {
  padding-top: 18pt;
  color: #000000;
  font-weight: 700;
  font-size: 18pt;
  padding-bottom: 4pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h3 {
  padding-top: 14pt;
  color: #000000;
  font-weight: 700;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h4 {
  padding-top: 12pt;
  color: #000000;
  font-weight: 700;
  font-size: 12pt;
  padding-bottom: 2pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h5 {
  padding-top: 11pt;
  color: #000000;
  font-weight: 700;
  font-size: 11pt;
  padding-bottom: 2pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h6 {
  padding-top: 10pt;
  color: #000000;
  font-weight: 700;
  font-size: 10pt;
  padding-bottom: 2pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  font: 12pt "Tahoma";
}
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.page {
  width: 21cm;
  height: 29.7cm;
  padding: 10mm;
  margin: 0;
  border: 2px #ffffff solid;
  border-radius: 0px;
  background: rgb(255, 255, 255);
  box-shadow: 0 0 0px rgba(0, 0, 0, 0.1);
}
.text-center {
  text-align: center !important;
}
.text-left {
  text-align: left !important;
}
.v-application {
  font-family: "Roboto", sans-serif;
  line-height: 1.5;
}
.v-input {
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
  font-size: 16px;
  letter-spacing: normal;
  max-width: 100%;
  text-align: left;
}
td {
  display: table-cell;
  vertical-align: inherit;
}
tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}
thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
}

@media print {
  .page {
    clear: both;
    page-break-after: always;
  }
}
.box {
  width: 21cm;
  padding: 0;
  margin: 0;
}
.subpage {
  padding: 0cm 1cm;
  border: 5px rgb(255, 255, 255) solid;
  height: 277mm;
  outline: 1cm #ffffff solid;
}
</style>
